export default "__VITE_ASSET__DGrZ7Xif__ 584w";